import { useMutation, useQueryClient } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { IRQCallbacks } from '../../../types/my-types';

const useDeleteVendor = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: number) => {
      return (await glynt).vendor.deleteVendor(id);
    },

    ...callbacks,

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ['vendors']
      });
    }
  });
};

export default useDeleteVendor;
